import {
	SET_CURRENT_USER,
	USER_LOADING,
	USER_REGISTER,
	GET_USERS,
	GET_ERRORS
} from "../actions/types";

const isEmpty = require("is-empty");

const initialState = {
	isAuthenticated: false,
	user: {},
	loading: false
};

export default function (state = initialState, action) {
	switch (action.type) {
		case SET_CURRENT_USER:
			return {
				...state,
				isAuthenticated: !isEmpty(action.payload),
				user: action.payload
			};
		case USER_LOADING:
			return {
				...state,
				loading: true
			};

		case GET_USERS:
			return {
				...state,
				users: action.payload
			};

		case USER_REGISTER:
			return {
				...state,
				message: action.payload,
				register: true
			};

		case GET_ERRORS:
			return {
				...state,
				error: action.payload
			};

		default:
			return state;
	}
}
